import { extendZodWithOpenApi } from "@anatine/zod-openapi";
import z from "zod/v3";

extendZodWithOpenApi(z);

export default z;
export { z };
